export default __webpack_public_path__ + "static/media/necromancer.e49e6d70.png";